import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { recordStatisticsEvent } from '../../../../services/statistics-service';
import WireCaption from './wire-caption';
import WireTitle from './wire-title';

// isWireCollapsed
const isWC = d => (d.items === 1 && !d.isBelow480);

const Container = styled.section`
  display: flex;

  & > .text-wrapper {
    display: flex;
    flex-direction: column;
  }

  & > .image-wrapper > img {
    object-fit: contain;
  }

  ${props => (isWC(props) ? `
    flex-direction: row-reverse;
    justify-content: space-between;

    & > * {
      flex-basis: 50%;
    }

    & > .image-wrapper {
      margin-left: 24px;
      text-align: right;

      > img {
        ${props.theme.isMobileOrTablet && `
          max-height: 194px;
        `};
        max-width: 100%;
      }
    }
  ` : `
    flex-direction: column;

    & > * {
      width: 100%;
    }

    & > .text-wrapper {
      margin-top: 16px;
    }

    & > .image-wrapper > img {
      max-width: 100%;
    }
  `)};
`;

export default function Wire({
  wire, items, mention, isBelow480, clickEventProps,
}) {
  const baseProps = { items, isBelow480 };
  const { id, type, name } = clickEventProps;

  const handleClick = () => {
    recordStatisticsEvent({
      event: name,
      statisticable: type,
      id,
      clicked_url: `/wires/${wire.slug}`,
      page: window.location.pathname,
    });

    return false;
  };

  return (
    <Container {...baseProps}>
      <a href={`/wires/${wire.slug}`} className="image-wrapper" onClick={handleClick}>
        <img src={wire.primaryImageUrl} alt={wire.title} title={wire.title} />
      </a>
      <div className="text-wrapper">
        <WireCaption {...baseProps} wire={wire} mention={mention} />
        <WireTitle {...baseProps} wire={wire} clickEventProps={clickEventProps} />
      </div>
    </Container>
  );
}

Wire.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isSponsored: PropTypes.bool.isRequired,
    primaryImageUrl: PropTypes.string.isRequired,
    ownedByCurrentUser: PropTypes.bool.isRequired,
    editorsPicked: PropTypes.bool.isRequired,
    featuredCount: PropTypes.number.isRequired,
    publishedAt: PropTypes.string.isRequired,
    profileId: PropTypes.number.isRequired,
    userId: PropTypes.number.isRequired,
    category: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    series: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
    contributor: PropTypes.shape({
      name: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string.isRequired,
      organization: PropTypes.string,
    }),
  }).isRequired,
  items: PropTypes.number.isRequired,
  mention: PropTypes.bool.isRequired,
  isBelow480: PropTypes.bool.isRequired,
  clickEventProps: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
